export const orderHeaders = {
  orderNo: {
    name: "Order No",
    width: 0.25,
  },
  docNumbers: {
    name: "Doc Numbers",
    width: 0.25,
  },
  organizationName: {
    name: "Organization",
    width: 0.4,
  },
  createdByEmail: {
    name: "Created By",
    width: 0.4,
  },
  requestType: {
    name: "Request Type",
    width: 0.3,
  },
  orderStatus: {
    name: "Status",
    width: 0.3,
    textAlign: "center",
    justifyContent: "center",
  },
  createdAt: {
    name: "Created At",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
  customerActions: {
    name: "Actions",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};

export const mdorderHeaders = {
  orderNo: {
    name: "Order No",
    width: 0.3,
  },
  docNumbers: {
    name: "Doc Numbers",
    width: 0.25,
  },
  organizationName: {
    name: "Organization",
    width: 0.5,
  },
  orderStatus: {
    name: "Status",
    width: 0.3,
    textAlign: "center",
  },
  createdAt: {
    name: "Created At",
    width: 0.4,
    textAlign: "center",
  },
  customerActions: {
    name: "Actions",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};

export const smorderHeaders = {
  orderNo: {
    name: "Order No",
    width: 0.25,
  },
  docNumbers: {
    name: "Doc Numbers",
    width: 0.5,
  },
  customerActions: {
    name: "Actions",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};
